module.exports = {

  /** Links with tokens */

  // Available tokens:
  // [STRIPE_PRICE_ID]: Replaced with Stripe price ID for the trial (defined below).
  // [SUBSCRIBERS]: Replaced with number of subscribers selected.
  // [PAGES]: Replaced with number of status pages selected.
  // [PRIVACY]: Replaced with private status pages value.

  trialLink: "https://app.sorryapp.com/people/sign_up?plan=[STRIPE_PRICE_ID]&subscribers=[SUBSCRIBERS]&pages=[PAGES]&privacy=[PRIVACY]",
  demoLink: "/demo?subscribers=[SUBSCRIBERS]&pages=[PAGES]&privacy=[PRIVACY]",


  /** Price page settings */

  // Stripe price IDs for the trial.
  stripePriceIdPlan: "price_0QSH3a596061iK2wzf4dPxQ4",

  // Base price
  basePrice: 99,

  // Features to show in the pricing card on the pricing page.
  features: [
    "1000 subscribers",
    "5 team members",
    "Incident metrics",
    "Component subscriptions",
    "Email notifications",
    "Slack / Teams / Google Chat notifications",
    "Custom domain",
    "REST API & Status API",
    "Team member SSO (with any SAML provider)",
    "Role-based access control for teams"
  ],


  /** Privacy / SSO */

  // Starting value for "private status pages" toggle.
  privacyAndSsoStart: false,
  // Added to price if "private status pages" is selected.
  privacyAndSsoPrice: 160,


  /** Subscribers */

  // Starting number of subscribers.
  subscribersStart: 1_000,
  // Change amount when + / -.
  subscriberIncrement: 1_000,
  // Minimum number of subscribers.
  subscribersMinimum: 1_000,
  // Maximum number of subscribers.
  subscribersMaximum: 16_000,
  // Added to price for each increment.
  subscribersPriceIncrement: 30,


  /** Pages */

  // Starting number of pages.
  pagesStart: 1,
  // Change amount when + / -.
  pageIncrement: 1,
  // Minimum number of pages.
  pagesMinimum: 1,
  // Maximum number of pages.
  pagesMaximum: 21,
  // Added to price for each increment.
  pagesPriceIncrement: 49

}
